/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactElement, useState, useContext, useEffect } from 'react'

import { DashboardContext } from 'live/context/dashboard'
import { WidgetContext } from 'live/context/widget'
import authorization from 'live/services/authorization'

import styled, { css, ThemeProvider } from 'styled-components'
import theme, { darkMode } from '../../theme/theme.js'
import _ from 'lodash'
import { StaticDataCharts } from './static-data-charts'
import { StaticDataProvider } from './context/StaticDataContext'

export const WidgetImpl = (widget: any, state, ...props: any[]): ReactElement => {
    const context = useContext(DashboardContext)
    const widgetContext = useContext(WidgetContext)
    const [updatedContainer, setUpdatedContainer] = useState(false)

    const hasPermissionToEdit =
        authorization.superAdmin ||
        authorization.admin ||
        authorization.Permission.ADMIN ||
        authorization.Permission.OGPERFORMANCE_MANAGE_KPI ||
        authorization.Permission.OGPERFORMANCE_ADMINISTRATE_KPI

    if (!updatedContainer && _.isFunction(widgetContext?.setCss)) {
        widgetContext.setCss(
            css`
                /* .widget-actions__download-button {
                    display: none;
                } */
                /* .widget-content-container {
                    padding: 0 !important;
                    background-color: ${context.theme === 'dark' ? darkMode['dark-bg'] : theme['gray-lighter']};
                    .highcharts-legend > rect {
                        fill: none !important;
                    }
                } */
                .widget-container {
                    height: 139px !important;
                }
                // Allow to see widget header.
                .widget-header {
                    display: none;
                }
                .widget-filters {
                    display: none !important;
                }
                &:not(.widget-fullscreen) .widget-actions {
                    > span:first-child,
                    > div:nth-of-type(3):not(.widget-edit-options) {
                        display: none;
                    }
                }
                &.widget-fullscreen .widget-actions {
                    > span:first-child,
                    > div:nth-of-type(2) {
                        display: none;
                    }
                }
            `
        )
        setUpdatedContainer(true)
    }

    const dashboardOptionsDisabledWhenUserDoesNotHavePermission = () => {
        if (!hasPermissionToEdit) {
            const editModeOption = document.querySelector(
                '.dashboard .main-submenu .dropdown-container .dropdown-menu>li:last-child'
            )
            const filterOption = document.querySelector('.filter-dropdown-toggle')

            if (editModeOption) {
                editModeOption.setAttribute(
                    'style',
                    `
                        pointer-events: none;
                        opacity: 0.6;
                        cursor: not-allowed !important;
                    `
                )
            }
            if (filterOption && !authorization.Permission.OGPERFORMANCE_VIEW_KPI) {
                filterOption.setAttribute(
                    'style',
                    `
                        pointer-events: none;
                        opacity: 0.5;
                        cursor: not-allowed !important;
                    `
                )
            }
        }
    }

    useEffect(() => {
        dashboardOptionsDisabledWhenUserDoesNotHavePermission()
    }, [context])

    return (
        <ThemeProvider theme={context.theme === 'dark' ? darkMode : { ...theme, 'dash-background': theme.white }}>
            <StaticDataProvider widget={widget} state={state} props>
                <WidgetContainer id="static-data-widget">
                    <StaticDataCharts width={props?.width} height={props?.height} />
                </WidgetContainer>
            </StaticDataProvider>
        </ThemeProvider>
    )
}

const WidgetContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    padding: 9px 0 9px 0;
`

export default WidgetImpl
